import { type ReactNode } from 'react';
import cn from 'classnames';
import styles from './eyebrow.module.scss';

export const Eyebrow = ({ text, icon = null, className }: Props) => {
	return (
		<div className={cn(styles.eyebrow, className)} data-testid="eyebrow">
			{icon}
			{text}
		</div>
	);
};

export interface Props {
	icon?: ReactNode;
	text: string;
	className?: string;
}
